const Header = (props) => (
    <h1 className='title josefin floatDown'>
        {props.title}
    </h1>
)

export default Header